import './brand.css';
export default {
  "brand": "pf-v6-c-brand",
  "modifiers": {
    "picture": "pf-m-picture"
  }
};